var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 378,
    viewBox: "0 0 378 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4769_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58324 134.695C1.18947 128.4 -0.382818 121.283 0.0428378 114.145C0.468494 107.006 2.87525 100.127 6.99299 94.28C13.7223 84.4066 22.7342 76.3023 33.264 70.655L151.405 9.167C163.017 3.12894 175.912 -0.0234375 189 -0.0234375C202.088 -0.0234375 214.983 3.12894 226.595 9.167L344.72 70.7023C355.25 76.3496 364.262 84.4538 370.991 94.3273C375.109 100.174 377.516 107.053 377.941 114.192C378.367 121.331 376.795 128.447 373.401 134.742C369.747 141.653 364.267 147.43 357.558 151.443C350.848 155.456 343.167 157.551 335.349 157.501H42.651C34.8257 157.549 27.1373 155.448 20.4244 151.427C13.7115 147.405 8.23187 141.617 4.58324 134.695ZM362.25 346.501C362.25 338.146 358.931 330.134 353.024 324.227C347.116 318.319 339.104 315.001 330.75 315.001V189.001H299.25V315.001H252V189.001H220.5V315.001H157.5V189.001H126V315.001H78.75V189.001H47.25V315.001C38.8957 315.001 30.8835 318.319 24.9761 324.227C19.0687 330.134 15.75 338.146 15.75 346.501C11.5728 346.501 7.56676 348.16 4.61306 351.114C1.65936 354.067 -8.90531e-06 358.073 -8.90531e-06 362.251C-8.90531e-06 366.428 1.65936 370.434 4.61306 373.387C7.56676 376.341 11.5728 378.001 15.75 378.001H362.25C366.427 378.001 370.433 376.341 373.387 373.387C376.341 370.434 378 366.428 378 362.251C378 358.073 376.341 354.067 373.387 351.114C370.433 348.16 366.427 346.501 362.25 346.501Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4769_165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 378,
    height: 378,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanque);
export default __webpack_public_path__ + "static/media/banque.ad16063479e6e2ab858343e685a0042c.svg";
export { ForwardRef as ReactComponent };